import React from 'react';
import ReactSelect, { SingleValue } from 'react-select';
import { ClinicSelectorOption, ClinicSelectorProps } from './interface';
import { isString } from './utils';
import useClinicOptions from './useClinicOptions';

function ClinicSelector(props: Readonly<ClinicSelectorProps>) {
  const { value: clinicsId, onChange } = props;

  const { options, selectedOptions } = useClinicOptions({
    selectedClinicsId: clinicsId
  });

  const handleSelectChange = (option: SingleValue<ClinicSelectorOption>) => {
    if (!option?.value) {
      onChange(null);
    }

    if (isString(option?.value)) {
      onChange(option.value);
    }
  };

  return (
    <ReactSelect
      placeholder="Enter Clinic name"
      options={options}
      value={selectedOptions}
      onChange={handleSelectChange}
    />
  );
}

export default ClinicSelector;
